<template>
  <el-select
    v-model="resellerInvoiceModel"
    @change="resellerInvoiceChanged"
    autocomplete="new-password"
    :placeholder="$t('COMMON.RESELLER_INVOICE')"
    :filterable="filterable"
    :multiple="multiple"
    :disabled="disabled"
    remote
    :remote-method="getResellerInvoices"
    :loading="loading"
  >
    <el-option
      v-if="showAll"
      :value="null"
      :label="$t('COMMON.RESELLER_INVOICE')"
    >
    </el-option>
    <el-option v-if="allowNone" :value="null" :label="$t('COMMON.NONE')">
    </el-option>
    <el-option
      v-for="resellerInvoice in resellerInvoices"
      :key="resellerInvoice.id"
      :value="resellerInvoice.id"
      :label="`${resellerInvoice.code}`"
    >
    </el-option>
  </el-select>
</template>

<script>
import { Option, Select } from "element-ui";

export default {
  name: "reseller-invoice-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    showAll: {
      type: Boolean,
      default: true,
      description: "Show the option all",
    },
    allowNone: {
      type: Boolean,
      default: false,
      description: "Show the option none",
    },
    filterable: {
      type: Boolean,
      default: true,
      description: "Can filter",
    },
    multiple: {
      type: Boolean,
      default: false,
      description: "Can filter",
    },
    resellerInvoice: {
      type: String,
      default: null,
      description: "ResellerInvoice id",
    },
    filterReseller: {
      type: String,
      default: null,
      description: "Reseller id",
    },
    filterOrganization: {
      type: String,
      default: null,
      description: "Organization id",
    },
    filterStatus: {
      type: String,
      default: null,
      description: "ResellerInvoice status",
    },
  },

  data() {
    return {
      resellerInvoiceModel: this.resellerInvoice,
      resellerInvoices: {},
    };
  },

  setup() {},

  created() {
    this.getResellerInvoices(null, this.resellerInvoice);
  },

  methods: {
    async getResellerInvoices(query = null, id = null) {
      try {
        this.loading = true;
        let params = {
          sort: "-created_at",
          filter: {
            ...(query ? { code: query } : {}),
            ...(id ? { id: id } : {}),
          },
          page: {
            number: 1,
            size: 10,
          },
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.filterOrganization,
            },
          };
        }
        if (this.filterReseller) {
          params = {
            ...params,
            filter: { ...params.filter, reseller: this.filterReseller },
          };
        }
        if (this.filterOrganization) {
          params = {
            ...params,
            filter: { ...params.filter, organization: this.filterOrganization },
          };
        }
        if (this.filterStatus) {
          params = {
            ...params,
            filter: { ...params.filter, status: this.filterStatus },
          };
        }

        await this.$store.dispatch("resellerInvoices/list", params);
        const resellerInvoicesArr = await this.$store.getters[
          "resellerInvoices/list"
        ];
        this.resellerInvoices = {};
        resellerInvoicesArr.forEach((resellerInvoice) => {
          this.resellerInvoices[resellerInvoice.id] = resellerInvoice;
        });
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    resellerInvoiceChanged(resellerInvoiceId) {
      const puchaseInvoice = Object.values(this.resellerInvoices).find(
        (item) => item.id === resellerInvoiceId
      );
      this.$emit("resellerInvoiceChanged", resellerInvoiceId, puchaseInvoice);
    },
  },

  watch: {
    resellerInvoice(resellerInvoice) {
      if (resellerInvoice) {
        this.resellerInvoiceModel = resellerInvoice;
        if (resellerInvoice !== this.resellerInvoiceModel) {
          this.getResellerInvoices(null, resellerInvoice);
        }
      } else {
        this.resellerInvoiceModel = null;
      }
    },
    filterOrganization(filterOrganization) {
      this.getResellerInvoices();
    },
    filterReseller() {
      this.getResellerInvoices();
    },
    filterStatus() {
      this.getResellerInvoices();
    },
  },
};
</script>
